<div #formRow class="form-group" [ngClass]="{ 'mb-0': noMarginBottom }" [ngStyle]="{ 'max-width.px': maxWidthPx }">
  <label *ngIf="label && label.length" class="d-flex justify-content-between">
    {{ label | translate }}
    <info-tooltip
      *ngIf="tooltipLabel && tooltipLabel.length > 0"
      [label]="tooltipLabel"
      [icon]="tooltipIcon"
    ></info-tooltip>
    <label class="float-right required" *ngIf="required"> ({{ 'required' | translate }}) </label>
  </label>
  <div class="input-group">
    <input
      [ngClass]="{
        'login-input': isLoginInput,
        'is-invalid': requiredCssClass || showErrorBorder,
        is_pristine: control && control.pristine,
        is_valid: control && !control.pristine && control.valid,
        is_invalid: control && !control.pristine && !control.valid,
      }"
      class="form-control"
      [type]="inputType"
      *ngIf="inputDisabled"
      [class]="classesString"
      [ngModel]="model"
      [readonly]="readonly"
      [attr.maxlength]="maxlength"
      [attr.data-cy]="dataCyAttribute"
      disabled
    />
    <input
      [ngClass]="{
        'login-input': isLoginInput,
        'is-invalid': requiredCssClass || showErrorBorder,
        is_pristine: control && control.pristine,
        is_valid: control && !control.pristine && control.valid,
        is_invalid: control && !control.pristine && !control.valid,
      }"
      class="form-control"
      [type]="inputType"
      *ngIf="!inputDisabled && !translateBarcode && !replaceComma && !inputMultiple"
      [class]="classesString"
      [ngModel]="model"
      (ngModelChange)="onNgModelChange($event, numberMax)"
      (keyup)="onInputKeyPress($event)"
      (change)="onInputValueChange($event)"
      (focus)="onFocus(true)"
      (blur)="onFocus(false)"
      [attr.data-track-category]="trackCategory"
      [attr.data-track-action]="trackAction"
      [required]="inputRequired"
      [min]="numberMin"
      [max]="numberMax"
      [attr.maxlength]="maxlength"
      [attr.name]="elementName"
      [placeholder]="placeholder ? (placeholder | translate) : ''"
      [readonly]="readonly"
      [attr.data-cy]="dataCyAttribute"
    />
    <input
      [ngClass]="{
        'login-input': isLoginInput,
        'is-invalid': requiredCssClass || showErrorBorder,
        is_pristine: control && control.pristine,
        is_valid: control && !control.pristine && control.valid,
        is_invalid: control && !control.pristine && !control.valid,
      }"
      class="form-control"
      [type]="inputType"
      *ngIf="!inputDisabled && translateBarcode && !replaceComma && !inputMultiple"
      translateBarcode
      [class]="classesString"
      [ngModel]="model"
      (ngModelChange)="onNgModelChange($event)"
      (keyup)="onInputKeyPress($event)"
      (focus)="onFocus(true)"
      (blur)="onFocus(false)"
      [attr.data-track-category]="trackCategory"
      [attr.data-track-action]="trackAction"
      [required]="inputRequired"
      [min]="numberMin"
      [max]="numberMax"
      [attr.maxlength]="maxlength"
      [attr.name]="elementName"
      [readonly]="readonly"
      [attr.data-cy]="dataCyAttribute"
    />
    <input
      [ngClass]="{
        'login-input': isLoginInput,
        'is-invalid': requiredCssClass || showErrorBorder,
        is_pristine: control && control.pristine,
        is_valid: control && !control.pristine && control.valid,
        is_invalid: control && !control.pristine && !control.valid,
      }"
      class="form-control"
      [type]="inputType"
      *ngIf="!inputDisabled && !translateBarcode && replaceComma && !inputMultiple"
      replaceComma
      [class]="classesString"
      [ngModel]="model"
      (ngModelChange)="onNgModelChange($event)"
      (keyup)="onInputKeyPress($event)"
      (focus)="onFocus(true)"
      (blur)="onFocus(false)"
      [attr.data-track-category]="trackCategory"
      [attr.data-track-action]="trackAction"
      [required]="inputRequired"
      [min]="numberMin"
      [max]="numberMax"
      [attr.name]="elementName"
      [readonly]="readonly"
      [attr.data-cy]="dataCyAttribute"
    />
    <input
      [ngClass]="{
        'login-input': isLoginInput,
        'is-invalid': requiredCssClass || showErrorBorder,
        is_pristine: control && control.pristine,
        is_valid: control && !control.pristine && control.valid,
        is_invalid: control && !control.pristine && !control.valid,
      }"
      class="form-control"
      [type]="inputType"
      *ngIf="!inputDisabled && translateBarcode && replaceComma && !inputMultiple"
      translateBarcode
      replaceComma
      [class]="classesString"
      [ngModel]="model"
      (ngModelChange)="onNgModelChange($event)"
      (keyup)="onInputKeyPress($event)"
      (focus)="onFocus(true)"
      (blur)="onFocus(false)"
      [attr.data-track-category]="trackCategory"
      [attr.data-track-action]="trackAction"
      [required]="inputRequired"
      [min]="numberMin"
      [max]="numberMax"
      [attr.name]="elementName"
      [readonly]="readonly"
      [attr.data-cy]="dataCyAttribute"
    />
    <input
      [ngClass]="{
        'login-input': isLoginInput,
        'is-invalid': requiredCssClass || showErrorBorder,
        is_pristine: control && control.pristine,
        is_valid: control && !control.pristine && control.valid,
        is_invalid: control && !control.pristine && !control.valid,
      }"
      class="form-control"
      [type]="inputType"
      *ngIf="!inputDisabled && !translateBarcode && !replaceComma && inputMultiple"
      multiple
      [class]="classesString"
      [ngModel]="model"
      (ngModelChange)="onNgModelChange($event)"
      (keyup)="onInputKeyPress($event)"
      (change)="onInputValueChange($event)"
      (focus)="onFocus(true)"
      (blur)="onFocus(false)"
      [attr.data-track-category]="trackCategory"
      [attr.data-track-action]="trackAction"
      [required]="inputRequired"
      [min]="numberMin"
      [max]="numberMax"
      [attr.name]="elementName"
      [readonly]="readonly"
      [attr.data-cy]="dataCyAttribute"
    />
    <ng-content></ng-content>
    <span class="input-group-unit my-auto ml-1 mr-1" *ngIf="appendUnitCm"><strong>cm</strong></span>
    <span class="input-group-unit my-auto ml-1 mr-1" *ngIf="appendUnitKg"><strong>kg</strong></span>
    <span class="input-group-unit my-auto ml-1 mr-1" *ngIf="appendUnitCurrency"
      ><strong>{{ currency | formatCurrencyWithoutPrice }}</strong></span
    >
    <span class="input-group-unit my-auto ml-1 mr-1" *ngIf="appendUnitPercent"><strong>%</strong></span>
    <span class="input-group-unit my-auto ml-1 mr-1" *ngIf="appendCustomText?.length"
      ><strong>{{ appendCustomText }}</strong></span
    >
    <div
      class="input-group-append"
      *ngIf="(appendBtnLabel && appendBtnLabel.length > 0) || (appendBtnIcon && appendBtnIcon.length > 0)"
    >
      <btn
        [label]="appendBtnLabel"
        [classes]="appendBtnClasses"
        [icon]="appendBtnIcon"
        [title]="appendBtnTitle"
        [disallowTabNavToBtn]="disallowTabNavToBtn"
        (onEvent)="onBtnClick($event)"
      ></btn>
    </div>
    <div class="input-group-append" *ngIf="appendCheckboxValue !== null && appendCheckboxShow">
      <div class="input-group-text">
        <label class="mb-0">
          <input
            type="checkbox"
            class="cursor-pointer"
            [ngModel]="appendCheckboxValue"
            [attr.data-cy]="dataCyAttribute"
            (ngModelChange)="onAppendedCheckboxChange($event)"
          />
          {{ appendCheckboxLabel }}
        </label>
      </div>
    </div>
    <div class="input-group-append d-flex align-items-center" *ngIf="appendCheckboxValue !== null && appendToggleShow">
      <div class="custom-control custom-switch flex-gap-5 ml-2">
        <input
          type="checkbox"
          class="custom-control-input"
          [id]="label + '_toggle'"
          tabindex="0"
          [ngModel]="modelToggle"
          [attr.data-cy]="dataCyAttribute"
          (ngModelChange)="onAppendedCheckboxChange($event)"
          [attr.data-track-category]="trackCategory"
          [attr.data-track-action]="trackAction"
        />
        <label class="custom-control-label" [for]="label + '_toggle'"> </label>
      </div>
    </div>
    <div
      *ngIf="requiredCssClass"
      [ngClass]="{ 'invalid-feedback': requiredCssClass }"
      style="color: #f0142f"
      data-cy="error_msg"
    >
      {{ errors | formError: formControlName | translate }}
    </div>
  </div>
</div>
